import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalRJCE = ({ toggleFunction, modalState }) => {
  // const modalTitle = 'Reconocimiento a Jefes de Residentes Año 2025 y Entrega de Carta de Egreso Año 2025'
  const titulo = 'La División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia LUZ'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-justify premio-dem'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner mb-4' /> */}

          <h3 className='modal-subtitle continuous mb-4 fs-base lh-base'>{titulo}</h3>


          <div className='info-group mb-3'>
            <p className='spaced-md'>Se complace en informar que el día jueves 04 de diciembre de 2025, a las 1:00 p.m, en el Auditorio “Dr. Antonio Borjas Romero”, se llevará a cabo la entrega de <b>Carta de Egreso</b> a los residentes que culminan su escolaridad en el segundo período académico del año 2025.</p>

            <p className='spaced-md'>En el mismo acto se otorgará un reconocimiento y el Botón emblema de la División de Estudios Para Graduados de nuestra Facultad de Medicina a los <b>Jefes de Residentes</b>, por su destacada labor durante el presente año.</p>
            
            <p className='spaced-md'>En vista de ser un acto formal debe asistir con bata médica blanca y estar una hora antes del inicio del acto.</p>

            <p className='mb-2'>Atentamente</p>
          </div>

          <div className='info-group w-100 justify-content-start'>
            <div className='d-flex flex-column'>
              <span className='fw-bold fs-base'>Dr. Freddy Pachano Arenas</span>
              <span className='fw-bold mb-2'>Director</span>
            </div>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalRJCE }